import React from 'react'
import IconContainer from '../components/IconContainer'
import {useNavigate} from 'react-router-dom'

const SearchIT = () => {

  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center">
    <IconContainer context='search-listings'/>
    <button
    className=" bg-green-900 px-4 py-2 rounded-full text-white font-semibold w-full hover:scale-110 hover:bg-bubble-gum"
    onClick={() => navigate("/get-listings")}
    >GET ALL ITEMS</button>
    </div>
  )
}

export default SearchIT



